/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  accept_assessment_kit_review_action,
  assessment_kit_reviewee_remark_action,
  get_candidate_assessment_response_data_action,
  get_candidate_assigned_assessment_details_action,
  reject_candidate_assessment_kit_action,
  shortlist_candidate_assessment_kit_action,
  create_candidate_response_rating_action,
  update_candidate_response_rating_action,
} from "../../../redux/_actions";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../_hooks/useAuthContext";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
function useViewAssessmentResponse() {
  const { user } = useContext(AuthContext);

  const [candidateResponse, setCandidateResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [candidateResponseLoading, setCandidateResponseLoading] =
    useState(false);
  const [isEditRemark, setIsEditRemark] = useState(false);
  const [question, setQuestion] = useState(null);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [assessementDetails, setAssessmentDetails] = useState(null);
  const [isShortlistRejectModal, setIsShortlistRejectModal] = useState(false);
  const [isAcceptReviewModal, setIsAcceptReviewModal] = useState(false);
  const [shortlistRejectType, setShortlistRejectType] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { candidateResponseData } = useSelector(
    (state) => state.get_candidate_assessment_response_reducer
  );
  const { assignedAssessmentDetailsData } = useSelector(
    (state) => state.get_candidate_assigned_assessment_details_reducer
  );

  useEffect(() => {
    const callApi = async (id) => {
      setLoading(true);
      await dispatch(get_candidate_assigned_assessment_details_action(id));
      setLoading(false);
    };

    let id = params?.assessmentId;
    if (id) callApi(id);
  }, [params]);

  useEffect(() => {
    if (assignedAssessmentDetailsData) {
      setAssessmentDetails(assignedAssessmentDetailsData);
      getCandidateResponse(
        assignedAssessmentDetailsData?.assessment_id?.id,
        assignedAssessmentDetailsData?.candidate_id?.id
      );
    }
  }, [assignedAssessmentDetailsData]);

  useEffect(() => {
    if (candidateResponseData) {
      setCandidateResponse(candidateResponseData);
      setQuestion(candidateResponseData[questionIndex ? questionIndex : 0]);
    }
  }, [candidateResponseData]);

  const getCandidateResponse = async (id, candidateId) => {
    setCandidateResponseLoading(true);
    await dispatch(
      get_candidate_assessment_response_data_action(id, candidateId)
    );
    setCandidateResponseLoading(false);
  };

  const acceptReviewClick = async () => {
    await dispatch(accept_assessment_kit_review_action(assessementDetails?.id));
    await dispatch(
      get_candidate_assigned_assessment_details_action(assessementDetails?.id)
    );
    setIsAcceptReviewModal((v) => !v);
  };

  const onNavigateBack = () => navigate(-1);

  const onQuestionRatingChange = async (val, ratingId) => {
    if (user?.user?.role === "mentor") {
      if (assessementDetails?.reviewed_by_id === null) {
        setIsAcceptReviewModal((v) => !v);
      }

      if (assessementDetails?.reviewed_by_id?.id === user?.user?.id) {
        /// apply rest of the rating logic here
        let res;
        if (ratingId) {
          res = await dispatch(
            update_candidate_response_rating_action(ratingId, {
              rating_value: val,
              assessment_candidate_question_response_id: question?.id,
            })
          );
        } else {
          res = await dispatch(
            create_candidate_response_rating_action({
              rating_value: val,
              assessment_candidate_question_response_id: question?.id,
            })
          );
        }

        if (res?.assessment_candidate_question_response_id) {
          await dispatch(
            get_candidate_assessment_response_data_action(
              assessementDetails?.assessment_id?.id,
              assessementDetails?.candidate_id?.id
            )
          );
        }
      } else {
        showWarningMessage("You are not authorised to  rating.");
      }
    } else showWarningMessage("You are not authorised to add rating.");
  };

  const onNextPrevClick = () => {
    setQuestion(candidateResponse[questionIndex + 1]);
    setQuestionIndex(questionIndex + 1);
  };

  const onRemarkInputBlur = async (e) => {
    const val = e.target.value;

    if (val !== "") {
      await dispatch(
        assessment_kit_reviewee_remark_action(assessementDetails?.id, {
          remark_by_reviewee: val,
        })
      );
      await dispatch(
        get_candidate_assigned_assessment_details_action(assessementDetails?.id)
      );
      setIsEditRemark(false);
    } else {
      showWarningMessage("Please enter your remark!");
    }
  };

  const onEditRemark = () => {
    setIsEditRemark((v) => !v);
  };

  const shortlistRejectClick = async () => {
    if (assessementDetails?.remark_by_reviewee === "") {
      showWarningMessage("Please enter remark.");
    } else {
      if (shortlistRejectType === ASSESSMENT_ASSIGN_STATUS.shortlisted) {
        await dispatch(
          shortlist_candidate_assessment_kit_action(assessementDetails?.id)
        );
      } else if (shortlistRejectType === ASSESSMENT_ASSIGN_STATUS.rejected) {
        await dispatch(
          reject_candidate_assessment_kit_action(assessementDetails?.id)
        );
      }
    }
    handleShortlistRejectModal("");
  };

  const handleAcceptReviewModal = () => {
    setIsAcceptReviewModal((v) => !v);
  };

  const handleShortlistRejectModal = (val) => {
    setIsShortlistRejectModal((v) => !v);
    setShortlistRejectType(val);
  };

  const onQuestionViewClick = (e) => {
    const selectedIndexNum = e.target.selectedIndex;
    setQuestion(candidateResponse[selectedIndexNum]);
    setQuestionIndex(selectedIndexNum);
  };

  const onAcceptReviewKit = () => {
    if (user?.user?.role === "mentor") {
      if (assessementDetails?.reviewed_by_id === null) {
        setIsAcceptReviewModal((v) => !v);
      }
    } else showWarningMessage("You are not authorised to add rating.");
  };
  return {
    user,
    assessementDetails,
    candidateResponse,
    question,
    loading,
    isEditRemark,
    questionIndex,
    shortlistRejectType,
    isAcceptReviewModal,
    isShortlistRejectModal,
    candidateResponseLoading,
    onAcceptReviewKit,
    onQuestionRatingChange,
    shortlistRejectClick,
    onRemarkInputBlur,
    onEditRemark,
    handleAcceptReviewModal,
    handleShortlistRejectModal,
    onQuestionViewClick,
    onNextPrevClick,
    acceptReviewClick,
    onNavigateBack,
  };
}

export default useViewAssessmentResponse;
